var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.484 2.984a1.5 1.5 0 00-1.045 2.577L35.88 24l-18.44 18.44a1.5 1.5 0 102.122 2.12l19.5-19.5a1.5 1.5 0 000-2.12l-19.5-19.5a1.5 1.5 0 00-1.077-.456z"
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTSAxOC40ODQzNzUgMi45ODQzNzUgQSAxLjUwMDE1IDEuNTAwMTUgMCAwIDAgMTcuNDM5NDUzIDUuNTYwNTQ2OSBMIDM1Ljg3ODkwNiAyNCBMIDE3LjQzOTQ1MyA0Mi40Mzk0NTMgQSAxLjUwMDE1IDEuNTAwMTUgMCAxIDAgMTkuNTYwNTQ3IDQ0LjU2MDU0NyBMIDM5LjA2MDU0NyAyNS4wNjA1NDcgQSAxLjUwMDE1IDEuNTAwMTUgMCAwIDAgMzkuMDYwNTQ3IDIyLjkzOTQ1MyBMIDE5LjU2MDU0NyAzLjQzOTQ1MzEgQSAxLjUwMDE1IDEuNTAwMTUgMCAwIDAgMTguNDg0Mzc1IDIuOTg0Mzc1IHoiIGZpbGw9IiMwMDAwMDAiLz48L3N2Zz4K";
export { SvgChevron as ReactComponent };